import { Router } from '@angular/router';

export interface StatRoute {
  readonly path: string;
  readonly queryParams?: { readonly status: 'verified' | 'absent' };
}

/**
 * A dónde lleva tocar una métrica del bloque: la lista de Asistentes del evento,
 * con el filtro que corresponda. `null` si no hay evento válido o la métrica no
 * tiene destino (las de tickets físicos).
 */
export function assistantsRouteForStat(eventId: number | string | null | undefined, titleKey: string): StatRoute | null {
  const id = Number(eventId);
  if (!Number.isFinite(id) || id <= 0) return null;

  const path = `/event-reports/event/${id}/assistants`;
  switch (titleKey) {
    case 'reports-single-event.tickets-sold':
    case 'reports-single-event.registered':
      return { path };
    case 'reports-single-event.verified':
      return { path, queryParams: { status: 'verified' } };
    case 'reports-single-event.absent':
      return { path, queryParams: { status: 'absent' } };
    default:
      return null;
  }
}

/**
 * Navega a Asistentes según la métrica tocada. Lo usan el Jefe (`HeaderKpisService`)
 * y el Vendedor (Mis ventas). Devuelve `false` si la métrica no tiene destino.
 */
export function navigateToStat(router: Router, eventId: number | string | null | undefined, titleKey: string): boolean {
  const route = assistantsRouteForStat(eventId, titleKey);
  if (!route) return false;
  if (route.queryParams) {
    router.navigate([route.path], { queryParams: route.queryParams });
  } else {
    router.navigate([route.path]);
  }
  return true;
}
